import { gql } from "@apollo/client";

export const DELETE_EXCEPTIONS = gql`
  mutation DeleteExceptions($input: ExceptionsDeleteInput!) {
    deleteExceptions(input: $input)
  }
`;
